import React from 'react'

const DataProcessingAddendum: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">

      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">
          Data Processing Addendum
        </h1>
        <p className="text-gray-600 mb-8">
          <strong>Effective Date:</strong> February 13, 2026
        </p>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 space-y-6 text-gray-700">
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              1. Institutional Service Clause
            </h3>
            <p>
              TrackIEP performs institutional services that the School would
              otherwise use its own employees to perform.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              2. Legitimate Educational Interest
            </h3>
            <p>
              TrackIEP accesses Student Data solely to fulfill legitimate
              educational interests determined by the School.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              3. Direct Control Clause
            </h3>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Use of Student Data</li>
              <li>Access permissions</li>
              <li>Data correction and deletion</li>
              <li>Disclosure decisions</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              4. No Re-Disclosure Clause
            </h3>
            <p>
              TrackIEP shall not disclose Student Data without written School
              authorization or legal requirement.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              5. Security Safeguards
            </h3>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Access controls</li>
              <li>Encryption</li>
              <li>Incident response plan</li>
              <li>Workforce training</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              6. Data Breach Notification
            </h3>
            <p>Notification within 72 hours of confirmed breach.</p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              7. Data Return and Destruction
            </h3>
            <p>
              Student Data will be returned or securely destroyed upon
              termination.
            </p>
          </section>
        </div>
      </main>

    </div>
  )
}

export default DataProcessingAddendum
